import React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as PlusIco} from "../../../../../../../../images/icons/plus.svg";
import {ReactComponent as EditIco} from "../../../../../../../../images/icons/edit.svg";
import {RootState} from "../../../../../../../../reducers";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";

interface OwnProps {
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPageNavbarButtons = ({session, setShowAddressModal}: Props) => {
    const {t} = useTranslation();

    return (
        <>
            <button className="btn btn-icon" onClick={() => setShowAddressModal(true)}
                    aria-label={
                        session.full_address ?
                            t("modules.multistore.action.edit_address.title") :
                            t("modules.multistore.action.set_address.title")
                    }
            >
                {session.full_address ? <EditIco aria-hidden="true"/> : <PlusIco aria-hidden="true"/>}
            </button>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPageNavbarButtons));